const AuthRedirectText = ({
    className,
    question,
    actionText,
    onAction
}) => {
    return (
        <div className={`tw-flex tw-w-full sm:tw-hidden tw-relative ${className}`}>
            <span className="tw-flex tw-m-auto tw-justify-center tw-pt-6 tw-cursor-pointer tw-ml-auto sm:tw-m-auto">
                <span
                    className="
                    tw-font-[450] 
                    tw-text-[14px] sm:tw-text-[16px]
                    tw-leading-[140%] 
                    tw-text-[#282828] sm:tw-text-[#282828]"
                >
                    {question}
                </span>

                <span
                    onClick={onAction}
                    className="
                    tw-font-['Raleway']
                    hover:tw-underline
                    tw-ml-2 tw-cursor-pointer
                    tw-font-[450] 
                    tw-text-[14px] sm:tw-text-[16px]
                    tw-leading-[140%] 
                  tw-text-[#549A9C] sm:tw-text-[#282828]"
                >
                    {actionText}
                </span>
            </span>
        </div>
    );
};

export default AuthRedirectText;